// Single source of truth for client-side session state.
//
// Auth tokens live in HttpOnly cookies set by the backend (`access_token`,
// `refresh_token`); JavaScript cannot read them. This module owns:
//   - the cached user blob in localStorage (for instant UI restore)
//   - access to the non-HttpOnly `csrf_auth` cookie (read for the
//     `X-CSRFToken` header on unsafe-method requests)
//   - the `hasSession` heuristic (presence of `csrf_auth`)

const USER_KEY = 'user';
// Env-suffixed on QA (csrf_auth_qa) so QA/prod cookies can't collide;
// default matches the backend's unsuffixed prod/local name.
const CSRF_COOKIE_NAME = process.env.REACT_APP_CSRF_COOKIE_NAME || 'csrf_auth';

function readCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function setSession({ user }) {
  if (user !== undefined) setUser(user);
}

export function clearSession() {
  localStorage.removeItem(USER_KEY);
}

export function getCsrfToken() {
  return readCookie(CSRF_COOKIE_NAME);
}

export function hasSession() {
  return !!getCsrfToken();
}
